import { forwardRef, useEffect, useState } from 'react'
import { Input, InputProps } from 'ui-kit/input'
import { useDebounceCallback } from 'usehooks-ts'

export interface DebouncedInputProps extends Omit<InputProps, 'onChange'> {
  value: string | undefined
  onChange: (value: string) => void
  debounce?: number
}

export const DebouncedInput = forwardRef<HTMLInputElement, DebouncedInputProps>(
  ({ value, onChange, debounce = 300, ...props }, ref) => {
    const [localValue, setLocalValue] = useState(value)
    const debouncedOnChange = useDebounceCallback(onChange, debounce)

    useEffect(() => {
      setLocalValue(value)
    }, [value])

    function handleOnChange(newValue: string) {
      setLocalValue(newValue)
      debouncedOnChange(newValue)
    }

    return <Input value={localValue} onChange={(e) => handleOnChange(e.target.value)} {...props} ref={ref} />
  },
)
